import { Node } from "@tiptap/core";

const ParagraphExtension = Node.create({
	name: "customParagraph",
	group: "block",
	content: "inline*",
	parseHTML() {
		return [{ tag: "p", priority: 1006 }];
	},
	renderHTML({ HTMLAttributes }) {
		console.log("entering paragraph extension");
		return ["p", HTMLAttributes, 0];
	}
});

export default ParagraphExtension;
